export interface BarChartItem {
  label: string;
  value: number;
}

export interface KpiCard {
  label: string;
  value: string;
  hint?: string;
}

export interface PieSlice {
  label: string;
  value: number;
  color: string;
}

export interface HistogramBucket {
  label: string;
  value: number;
}

export interface LineSeries {
  name: string;
  color: string;
  values: number[];
}

export const DASHBOARD_SERVICOS_KPIS: KpiCard[] = [
  { label: 'Limpezas no período', value: '1.842', hint: '+12% vs mês anterior' },
  { label: 'Média de caminhões/dia', value: '61', hint: 'Limpezas/dia no período' },
  { label: 'Terminais ativos', value: '4', hint: 'Com movimentação' },
  { label: 'Receita no período', value: 'R$ 128.000,00', hint: 'Serviços no período' }
];

export const DASHBOARD_PATIO_KPIS: KpiCard[] = [
  { label: 'Permanência média', value: '6,2 h', hint: 'Entrada até saída' },
  { label: 'Agendamento → pátio', value: '45 min', hint: 'Mediana' },
  { label: 'Agendamentos', value: '326', hint: '87% confirmados' },
  { label: 'Veículos no pátio', value: '48', hint: 'Média no período' }
];

/** @deprecated Use DASHBOARD_SERVICOS_KPIS ou DASHBOARD_PATIO_KPIS */
export const DASHBOARD_KPIS: KpiCard[] = DASHBOARD_SERVICOS_KPIS;

export const LIMPEZAS_POR_MES: BarChartItem[] = [
  { label: 'Jan', value: 142 },
  { label: 'Fev', value: 128 },
  { label: 'Mar', value: 156 },
  { label: 'Abr', value: 171 },
  { label: 'Mai', value: 163 },
  { label: 'Jun', value: 189 }
];

export const LIMPEZAS_POR_TERMINAL: BarChartItem[] = [
  { label: 'Terminal A', value: 412 },
  { label: 'Terminal B', value: 358 },
  { label: 'Terminal C', value: 291 },
  { label: 'Terminal D', value: 224 },
  { label: 'Sem Carreg.', value: 87 }
];

export const LIMPEZAS_POR_TRANSPORTADORA: BarChartItem[] = [
  { label: 'Transp. Alfa', value: 298 },
  { label: 'Transp. Beta', value: 245 },
  { label: 'Transp. Gama', value: 201 },
  { label: 'Transp. Delta', value: 178 },
  { label: 'Outras', value: 142 }
];

export const MEDIA_MENSAL_SERVICOS: { labels: string[]; series: LineSeries[] } = {
  labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
  series: [
    { name: 'Higienização', color: '#2563eb', values: [118, 112, 130, 138, 142, 151] },
    { name: 'Pátio e Limpeza', color: '#16a34a', values: [86, 79, 91, 88, 94, 98] },
    { name: 'Agend. Higienização', color: '#d97706', values: [42, 48, 45, 52, 49, 55] }
  ]
};

export const FORMA_PAGAMENTO: PieSlice[] = [
  { label: 'PIX', value: 38, color: '#2563eb' },
  { label: 'Dinheiro', value: 22, color: '#16a34a' },
  { label: 'Cartão Crédito', value: 18, color: '#7c3aed' },
  { label: 'Cartão Débito', value: 12, color: '#0891b2' },
  { label: 'A Prazo', value: 10, color: '#d97706' }
];

export const AGENDAMENTOS_STATUS: BarChartItem[] = [
  { label: 'Confirmados', value: 284 },
  { label: 'Aguardando', value: 28 },
  { label: 'Cancelados', value: 14 }
];

export const TEMPO_AGENDAMENTO_PATIO: HistogramBucket[] = [
  { label: '< 30 min', value: 92 },
  { label: '30–60 min', value: 118 },
  { label: '1–2 h', value: 76 },
  { label: '2–4 h', value: 34 },
  { label: '> 4 h', value: 12 }
];

export const PERMANENCIA_PATIO: HistogramBucket[] = [
  { label: '< 2 h', value: 45 },
  { label: '2–4 h', value: 88 },
  { label: '4–8 h', value: 142 },
  { label: '8–12 h', value: 96 },
  { label: '> 12 h', value: 38 }
];
